<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
      :for="name"
    >
      <h3>
        {{ label }}
      </h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <textarea
      :id="name"
      v-model="model"
      class="ui-type-area form-control custom-scrollbar"
      :disabled="isDisabled"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :rows="rows"
      :spellcheck="spellcheck"
    ></textarea>
    <span
      v-if="countChar || maxlength"
      class="text-count has-text-right mt-2"
    >
      {{ characterCounter }}
    </span>
  </div>
</template>

<script>
import commonProperties from './common-properties';

export default {
  name: 'LongText',
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    default: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: null,
    },
    rows: {
      type: Number,
      default: 5,
    },
    spellcheck: {
      type: Boolean,
      default: true,
    },
    countChar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    characterCounter() {
      const max = this.maxlength ? `/${this.maxlength}` : '';
      const counter = this.model
        ? this.formatCountedChars(this.model.length)
        : 0;

      return `${counter}${max} caracteres`;
    },
  },
  methods: {
    formatCountedChars(amount) {
      if (amount > 999) {
        return amount.toLocaleString('pt-BR', { useGrouping: true });
      }
      return amount;
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

textarea.form-control {
  background-color: $lighter;
  font-size: $size-small;
  color: $darker;
  border: 1px solid $light;
  border-radius: 4px;
  padding: 10px 16px;

  &::placeholder {
    color: $light;
  }

  &:focus {
    border-color: $crm-blue-primary;
  }
}

.text-count {
  width: 100%;
  display: block;
  font-size: $size-smaller;
  color: $gray-50;
  font-weight: $lb-medium;
}

.help-text {
  margin-top: 0;
  margin-bottom: 1em;
}
</style>
